var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 181.65 190.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;}.cls-1,.cls-2{fill:currentColor;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.24,141.02l26.8,27.18c4.98,5.05,5,13.15.05,18.22h0c-5.02,5.14-13.26,5.25-18.4.23l-27.36-26.7c-9.25,5.76-19.93,8.8-30.82,8.78C26.19,168.74,0,142.49,0,110.24s26.25-58.5,58.5-58.5,58.5,26.25,58.5,58.5c.02,10.88-3.02,21.54-8.76,30.78ZM17.97,109.81c0,22.32,18.13,40.5,40.5,40.5s40.5-18.13,40.5-40.5-18.13-40.5-40.5-40.5-40.5,18.13-40.5,40.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M181.65,72.07c0,4.7-2.46,9.94-4.85,15-2.02,4.3-4.12,8.75-4.65,12.75-.32,2.41-1.6,5.45-2.69,7.7-1.03,2.12-3.1,3.55-5.45,3.68-.08,0-.15,0-.21,0-1.28,0-2.86-.87-3.13-4.99v-.08s-.04-4.14-.04-4.14c-.01-4.24-3.01-6.17-5.79-6.17s-5.78,1.93-5.79,6.17l-.04,4.14v.08c-.28,4.12-1.86,4.99-3.14,4.99h0c-.06,0-.13,0-.21,0-2.31-.13-4.38-1.52-5.4-3.6-1.11-2.27-2.42-5.35-2.75-7.79-.53-4-2.63-8.45-4.65-12.75-2.38-5.06-4.85-10.3-4.85-15,0-8.65,6.68-15.69,14.88-15.69,3.37,0,5.76,1.76,7.87,3.32,1.5,1.11,2.8,2.07,4.07,2.07s2.57-.96,4.07-2.07c2.11-1.56,4.49-3.32,7.87-3.32,4.95,0,9.33,2.56,12.04,6.48,1.78,2.59,2.84,5.77,2.84,9.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.12,4.84l5.84,5.8-22.17,22.17-5.71-5.69-.33-.33c-6.15-6.08-6.19-16.02-.11-22.17.96-.97,2.04-1.81,3.21-2.49,6.13-3.58,13.92-2.6,18.95,2.38l.32.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.78,43.47c-.95.97-2.04,1.81-3.21,2.49-6.13,3.58-13.92,2.6-18.95-2.38l-6.15-6.11,22.17-22.17,5.71,5.68.33.33c6.15,6.08,6.19,16.02.11,22.17Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.fcc667688dee2aa39d6ca353dca0f403.svg";
export { ForwardRef as ReactComponent };